/** Authenticate frame. The bearer is required once the worker has require-token on. */
export const authenticateMessage = (
  tenantId: string | null | undefined,
  userId: string | null | undefined,
  apiKey: string | null | undefined,
  accessToken: string | null,
  securityContext?: string | null,
): { action: "authenticate"; headers: Record<string, string> } => {
  const headers: Record<string, string> = {};

  if (tenantId) {
    headers["x-tenant-id"] = tenantId;
    headers["x-security-context"] = securityContext || tenantId;
  }

  if (userId) {
    headers["x-user-id"] = userId;
  }

  if (apiKey) {
    headers["x-api-key"] = apiKey;
  }

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  return { action: "authenticate", headers };
};
